export default "__VITE_ASSET__BIsgp0Gp__"